module.exports = __webpack_public_path__ + "static/media/barcode.ba63f746.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/barcode.svg
// module id = 1390
// module chunks = 0